/* eslint-disable */
export function isEmail(value) {
  var reg = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  return reg.test(value.trim());
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/validate/email.js
// module id = 363
// module chunks = 74